import { Flex, Box, Button } from '@cad-arc';
import React from 'react';

interface ManageEventMergeManagerFooterProps {
    onSave: () => void;
    onCancel: () => void;
    isLoading: boolean;
    canSubmit: boolean;
}

export const ManageEventMergeManagerFooter: React.FC<ManageEventMergeManagerFooterProps> = ({
    onSave,
    onCancel,
    isLoading,
    canSubmit,
}) => {
    return (
        <Flex w="100%" justifyContent="flex-end">
            <Box mr="4px">
                <Button variant="ghost" onClick={onCancel}>
                    Cancel
                </Button>
            </Box>
            <Button
                isLoading={isLoading}
                loadingText="Saving..."
                variant="solid"
                disabled={isLoading || !canSubmit}
                onClick={onSave}
            >
                Save
            </Button>
        </Flex>
    );
};
